import { forwardRef } from 'react';
import moment from 'moment';
import IcRightArrow from '../../../assets/image/ic_chevron_right.svg';
import IcComment from '../../../assets/image/community/ic_comment.svg';
import IcLike from '../../../assets/image/community/ic_like.svg';

interface PostCardProps {
  post: any;
  onClick: (id: number) => void;
}

const PostCard = forwardRef<HTMLButtonElement, PostCardProps>(({ post, onClick }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className="w-full flex items-center justify-between py-4 border-b border-gray-200 hover:bg-gray-50 overflow-hidden"
      onClick={() => onClick(post?.id)}
    >
      <div className="grow min-w-0 overflow-hidden">
        <div className="w-full text-left mb-2 font-[400] text-[12px] text-[#363636] truncate overflow-hidden whitespace-nowrap">
          {post?.author?.nickName}
        </div>
        <div className="w-full text-left font-[700] text-[16px]">{post?.title}</div>
        <div className="w-full mb-3 text-left font-[400] text-[12px] text-[#363636] truncate overflow-hidden whitespace-nowrap">
          {post?.content}
        </div>
        <div className="w-full flex justify-between items-center">
          <div className="text-xs text-gray-500">{moment(post?.createdAt).format('YY.MM.DD')}</div>
          <div className="flex justify-end items-center text-[12px]">
            <img src={IcComment} alt="chevron right" className="w-[18px] h-[18px]" />
            <span className="ml-1 text-[#969696]">{post?.commentCount}</span>
            <img src={IcLike} alt="chevron right" className="ml-2 w-[18px] h-[18px]" />
            <span className="ml-1 text-[#969696]">{post?.likeCount}</span>
          </div>
        </div>
      </div>
      <div className="shrink-0 flex items-center justify-center w-[20px]">
        <img src={IcRightArrow} alt="chevron right" className="min-w-[18px] w-[18px] h-[18px]" />
      </div>
    </button>
  );
});

export default PostCard;
